module.exports = __webpack_public_path__ + "static/img/chain-height.07615649.png";